import React, { useRef } from 'react'
import { IoPrint } from 'react-icons/io5';
import { useReactToPrint } from 'react-to-print';
import Barcode from './Barcode';
import { FaRegEye } from 'react-icons/fa6';

const PrintSingleSlip = ({ order, btnText, previewId }) => {


    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });



    return (
        <>
            {/* Print Button */}

            <div className="oms-icon-btn edit" title="Edit"
                onClick={reactToPrintFn}
            >
                {btnText ? <FaRegEye size={15} /> : <IoPrint size={15} />}


                {/* ✏ */}
            </div>


            <div className="print-wrapper printContent" ref={contentRef}>

                {previewId === 1 && (

                    < div className="container-fluid d-flex flex-column mt-3">


                        {
                            order ? (
                                < div className="row g-0" key={order?.id}>
                                    <div className="border border-2 border-dark" style={{ height: "30" }}>


                                        {/* Receiver */}
                                        <div className="col-12 ">
                                            <div className="border-bottom border-dark fw-bold text-center" >
                                                Receiver Detail
                                            </div>
                                            <div className="row px-1">
                                                <div className="col-6 fw-bold mt-2">
                                                    <Barcode orderId={order?.trackingId} />

                                                    {/* Office Record ID : {order?.trackingId} */}
                                                </div>
                                                <div className="col-6 text-end fw-bold">
                                                    Amount : {
                                                        order?.amount
                                                            ? (Number(order.amount) < 10000
                                                                ? Number(order.amount) - 75
                                                                : Number(order.amount) - 100)
                                                            : 0
                                                    }
                                                </div>
                                            </div>

                                            <div className="p-2">

                                                <p><b>Name:</b> {order?.customerName}</p>
                                                <p><b>Address:</b> {order?.address}</p>
                                                <p><b>Contact:</b> {order?.phoneNumber}</p>
                                                <p><b>City:</b> {order?.city}</p>
                                            </div>
                                        </div>

                                        {/* Sender */}
                                        <div className="col-12">
                                            <div className="border-bottom border-dark fw-bold text-center"></div>

                                            <div className="row align-items-center">
                                                <div className="col">

                                                    <div className="text-center fw-bold p-2" style={{ fontSize: "14px" }}>
                                                        (Bulk User) AR E-Cart
                                                        P.O Box No. 2110
                                                        <br />
                                                        Nazimabad HPO
                                                        Karachi
                                                        <br />
                                                        0300-4919318
                                                        <br />
                                                        {" موجود ہے۔ شکریہ۔ (CNIC) پارسل کی بروقت اور یقینی ترسیل کو ممکن بنائیں۔"}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>


                                    </div>


                                </div>
                            ) : (
                                <>
                                    < div className="row g-0" key={order?.id}>
                                        <div className="border border-2 border-dark" style={{ height: "30" }}>


                                            {/* Receiver */}
                                            <div className="col-12 ">
                                                <div className="border-bottom border-dark fw-bold text-center" >
                                                    Receiver Detail
                                                </div>
                                                <div className="row px-1">
                                                    <div className="col-6 fw-bold mt-2">
                                                        <Barcode orderId={"Template 1"} />

                                                        {/* Office Record ID : {order?.trackingId} */}
                                                    </div>
                                                    <div className="col-6 text-end fw-bold">
                                                        Amount : 3125
                                                    </div>
                                                </div>

                                                <div className="p-2">

                                                    <p><b>Name:</b> Saleem Ahmed</p>
                                                    <p><b>Address:</b> House No 452/2 street no 5 lahore </p>
                                                    <p><b>Contact:</b> 0300-0001452</p>
                                                    <p><b>City:</b>Lahore</p>
                                                </div>
                                            </div>

                                            {/* Sender */}
                                            <div className="col-12">
                                                <div className="border-bottom border-dark fw-bold text-center"></div>

                                                <div className="row align-items-center">
                                                    <div className="col">

                                                        <div className="text-center fw-bold p-2" style={{ fontSize: "14px" }}>
                                                            (Bulk User)
                                                            P.O Box No. 5145
                                                            <br />
                                                            Nazimabad HPO
                                                            Karachi
                                                            <br />
                                                            0301-9874563
                                                            <br />
                                                            {" موجود ہے۔ شکریہ۔ (CNIC) پارسل کی بروقت اور یقینی ترسیل کو ممکن بنائیں۔"}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>


                                        </div>


                                    </div>
                                </>
                            )
                        }

                    </div>
                )}

                {previewId === 2 && (

                    < div className="container-fluid d-flex flex-column mt-3">


                        {
                            order ? (
                                < div className="row g-0" key={order?.id}>
                                    <div className="border border-2 border-dark" style={{ height: "30" }}>


                                        {/* Receiver */}
                                        <div className="col-12 ">
                                            <div className="border-bottom border-dark fw-bold text-center" >
                                                Receiver Detail
                                            </div>
                                            <div className="row px-1">
                                                <div className="col-6 fw-bold mt-2">
                                                    <Barcode orderId={order?.trackingId} />

                                                    {/* Office Record ID : {order?.trackingId} */}
                                                </div>
                                                <div className="col-6 text-end fw-bold">
                                                    Amount : {
                                                        order?.amount
                                                            ? (Number(order.amount) < 10000
                                                                ? Number(order.amount) - 75
                                                                : Number(order.amount) - 100)
                                                            : 0
                                                    }
                                                </div>
                                            </div>

                                            <div className="p-2">

                                                <p><b>Name:</b> {order?.customerName}</p>
                                                <p><b>Address:</b> {order?.address}</p>
                                                <p><b>Contact:</b> {order?.phoneNumber}</p>
                                                <p><b>City:</b> {order?.city}</p>
                                            </div>
                                        </div>

                                        {/* Sender */}
                                        <div className="col-12">
                                            <div className="border-bottom border-dark fw-bold text-center"></div>

                                            <div className="row align-items-center">
                                                <div className="col">

                                                    <div className="text-center fw-bold p-2" style={{ fontSize: "14px" }}>
                                                        (Bulk User) AR E-Cart
                                                        P.O Box No. 2110
                                                        <br />
                                                        Nazimabad HPO
                                                        Karachi
                                                        <br />
                                                        0300-4919318
                                                        <br />
                                                        {" موجود ہے۔ شکریہ۔ (CNIC) پارسل کی بروقت اور یقینی ترسیل کو ممکن بنائیں۔"}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>


                                    </div>


                                </div>
                            ) : (
                                <>
                                    < div className="row g-0" key={order?.id}>
                                        <div className="border border-2 border-dark" style={{ height: "30" }}>


                                            {/* Receiver */}
                                            <div className="col-12 ">
                                                <div className="border-bottom border-dark fw-bold text-center" >
                                                    Receiver Detail
                                                </div>
                                                <div className="row px-1">
                                                    <div className="col-6 fw-bold mt-2">
                                                        <Barcode orderId={"Template 2"} />

                                                        {/* Office Record ID : {order?.trackingId} */}
                                                    </div>
                                                    <div className="col-6 text-end fw-bold">
                                                        Amount : 3125
                                                    </div>
                                                </div>

                                                <div className="p-2">

                                                    <p><b>Name:</b> Saleem Ahmed</p>
                                                    <p><b>Address:</b> House No 452/2 street no 5 lahore </p>
                                                    <p><b>Contact:</b> 0300-0001452</p>
                                                    <p><b>City:</b>Lahore</p>
                                                </div>
                                            </div>

                                            {/* Sender */}
                                            <div className="col-12">
                                                <div className="border-bottom border-dark fw-bold text-center"></div>

                                                <div className="row align-items-center">
                                                    <div className="col">

                                                        <div className="text-center fw-bold p-2" style={{ fontSize: "14px" }}>
                                                            (Bulk User)
                                                            P.O Box No. 5145
                                                            <br />
                                                            Nazimabad HPO
                                                            Karachi
                                                            <br />
                                                            0301-9874563
                                                            <br />
                                                            {" موجود ہے۔ شکریہ۔ (CNIC) پارسل کی بروقت اور یقینی ترسیل کو ممکن بنائیں۔"}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>


                                        </div>


                                    </div>
                                </>
                            )
                        }

                    </div>
                )}


                {previewId === 3 && (

                    < div className="container-fluid d-flex flex-column mt-3">


                        {
                            order ? (
                                < div className="row g-0" key={order?.id}>
                                    <div className="border border-2 border-dark" style={{ height: "30" }}>


                                        {/* Receiver */}
                                        <div className="col-12 ">
                                            <div className="border-bottom border-dark fw-bold text-center" >
                                                Receiver Detail
                                            </div>
                                            <div className="row px-1">
                                                <div className="col-6 fw-bold mt-2">
                                                    <Barcode orderId={order?.trackingId} />

                                                    {/* Office Record ID : {order?.trackingId} */}
                                                </div>
                                                <div className="col-6 text-end fw-bold">
                                                    Amount : {
                                                        order?.amount
                                                            ? (Number(order.amount) < 10000
                                                                ? Number(order.amount) - 75
                                                                : Number(order.amount) - 100)
                                                            : 0
                                                    }
                                                </div>
                                            </div>

                                            <div className="p-2">

                                                <p><b>Name:</b> {order?.customerName}</p>
                                                <p><b>Address:</b> {order?.address}</p>
                                                <p><b>Contact:</b> {order?.phoneNumber}</p>
                                                <p><b>City:</b> {order?.city}</p>
                                            </div>
                                        </div>

                                        {/* Sender */}
                                        <div className="col-12">
                                            <div className="border-bottom border-dark fw-bold text-center"></div>

                                            <div className="row align-items-center">
                                                <div className="col">

                                                    <div className="text-center fw-bold p-2" style={{ fontSize: "14px" }}>
                                                        (Bulk User) AR E-Cart
                                                        P.O Box No. 2110
                                                        <br />
                                                        Nazimabad HPO
                                                        Karachi
                                                        <br />
                                                        0300-4919318
                                                        <br />
                                                        {" موجود ہے۔ شکریہ۔ (CNIC) پارسل کی بروقت اور یقینی ترسیل کو ممکن بنائیں۔"}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>


                                    </div>


                                </div>
                            ) : (
                                <>
                                    < div className="row g-0" key={order?.id}>
                                        <div className="border border-2 border-dark" style={{ height: "30" }}>


                                            {/* Receiver */}
                                            <div className="col-12 ">
                                                <div className="border-bottom border-dark fw-bold text-center" >
                                                    Receiver Detail
                                                </div>
                                                <div className="row px-1">
                                                    <div className="col-6 fw-bold mt-2">
                                                        <Barcode orderId={"Template 3"} />

                                                        {/* Office Record ID : {order?.trackingId} */}
                                                    </div>
                                                    <div className="col-6 text-end fw-bold">
                                                        Amount : 3125
                                                    </div>
                                                </div>

                                                <div className="p-2">

                                                    <p><b>Name:</b> Saleem Ahmed</p>
                                                    <p><b>Address:</b> House No 452/2 street no 5 lahore </p>
                                                    <p><b>Contact:</b> 0300-0001452</p>
                                                    <p><b>City:</b>Lahore</p>
                                                </div>
                                            </div>

                                            {/* Sender */}
                                            <div className="col-12">
                                                <div className="border-bottom border-dark fw-bold text-center"></div>

                                                <div className="row align-items-center">
                                                    <div className="col">

                                                        <div className="text-center fw-bold p-2" style={{ fontSize: "14px" }}>
                                                            (Bulk User)
                                                            P.O Box No. 5145
                                                            <br />
                                                            Nazimabad HPO
                                                            Karachi
                                                            <br />
                                                            0301-9874563
                                                            <br />
                                                            {" موجود ہے۔ شکریہ۔ (CNIC) پارسل کی بروقت اور یقینی ترسیل کو ممکن بنائیں۔"}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>


                                        </div>


                                    </div>
                                </>
                            )
                        }

                    </div>
                )}

                
            </div >
        </>
    )
}

export default PrintSingleSlip
